import React from "react";
import "../../Style/Home/customersLove.css";

function CustomersLove() {
  return (
    <div className="customers-love">
      <h1>
        We believe in, what our <br /> Customers Love
      </h1>
      <h4>
        Superior Quality | Expert's team | Precision | 24*7 Service Support |
        Out of the box features
      </h4>
    </div>
  );
}

export default CustomersLove;
